import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable, ReplaySubject } from 'rxjs';
import { Condition, DateField } from '../../../models';
import { AdminService, ApiService, AuthService, ConditionService, FormulaService, MetadataService, ModalService, SessionService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';

@Component({
  selector: 'sn-usc-book-of-business',
  templateUrl: './usc-book-of-business.component.html',
  styleUrls: ['../usc-store.component.css', './usc-book-of-business.component.css']
})
export class UscBookOfBusinessComponent implements OnInit {

    public all_items:Array<any> = [];  
    public items:Array<any> = [];  
    public columnFields:Array<any> = [];
    public filterFields:Array<any> = [];
    public viewConditions:Array<any> = [];
    public viewFormulas:Array<any> = [];
    public viewSettings:any;
    view:string = this.uscStoreService.view_book_of_business;
    // search
    public searchText:string;
    // paging 
    public curPage:number = 1;
    public pageSize:number = 15;
    public pageCount:number = 0;
    public itemCount:number = 0;
    public orderBy: string = 'sr_close_date';
    public asc:boolean = false;
    public enforceClientSidePaging: boolean = false;
    public enforceClientSideSorting: boolean = false;
    public enforceClientSideFiltering: boolean = false;
    protected conditionResults:Array<Condition> = [];
    public isLoading = true;
    public bServerReloadRequired = false;
    public selectedItemIDCount:number = 0;

    private filterMetaDataLoadedSubject = new ReplaySubject<boolean>();
    public filterMetaDataLoaded = this.filterMetaDataLoadedSubject.asObservable();
    private viewMetaDataLoadedSubject = new ReplaySubject<boolean>();
    public viewMetaDataLoaded = this.viewMetaDataLoadedSubject.asObservable();

    public data_filters:any = {
        sql_close_date: [],
    }
    
    public current_filters:any = {
        //close_date: { label: "", value: "" },
    }

    constructor(
        public ngbModal: NgbModal,
        public modalService: ModalService,
        public adminService: AdminService,
        public metadataService: MetadataService,
        public authService: AuthService,
        public apiService: ApiService,
        public sessionService: SessionService,
        public conditionService: ConditionService,
        public uscStoreService: UscStoreService,
        public formulaService: FormulaService
    ) { 
        console.log('UscBookOfBusinessComponent constructor');
    }

    ngOnInit() {
        this.loadMetaData();
    }
            
    loadMetaData() {
        this.loadTableViewMetaData();
        // var params = this.getSearchParams();
        // var filters = JSON.parse(params.f);
        // setTimeout(() => {
        //     this.loadFilterMetaDeta(this.filterFields, 0);
        // }, 100);
    }

    loadFilterMetaDeta(filterFields, index) {
        var params = this.getSearchParams();
        //var f = filters[index];
        var f = filterFields[index];
        console.log(f);
        if (this.enforceClientSideFiltering && f.is_column_filter) {
            if (index + 1 >= filterFields.length) {
                this.reloadItems();
            }
        } else {
            params.return_filter = f.key;
            this.uscStoreService.getMetaData(this.view, params, true).subscribe(
                result => {
                    this.data_filters[f.key] = result.meta_data.data_filter[f.key];
                    // var index = this.filterFields.findIndex(f => f.key == f.field);
                    // var filter_field = (index >= 0) ? this.filterFields[index] : null;
                    // var filter_field = filterFields.find(f => f.key == f.field);
                    if (f.is_required_on_load) {
                        this.current_filters[f.key] = result.meta_data.data_filter[f.key][0];
                        this.current_filters[f.key].op = f.op;
                    }
                    // if (f.field == "sql_close_date" && this.current_filter.close_date.value == "") {
                    //     //this.current_filter.close_date = result.meta_data.data_filter[f.field][0];
                    // }

                    // if (this.enforceClientSideFiltering) {
                    //     this.columnFields.forEach(f => {
                    //         if (f.enable_filtering) {
                    //             this.
                    //         }
                    //     })
                    // } else 
                    console.log(f.field, this.data_filters[f.field]);
                    if (index + 1 < filterFields.length) {
                        setTimeout(() => {
                            this.loadFilterMetaDeta(filterFields, index + 1);
                        }, 1 * 100);
                    } else {
                        // only load items after all filter metadata have been loaded
                        this.reloadItems();
                    }
                }, err => { console.log(err) }
            );
        }
    }

    loadTableViewMetaData() {
        console.log("loadMetaData");
        // column fields
        this.metadataService.loadMetadata().subscribe(
            data => { 
                // wait till default meta data is load before laoding table view meta data
                this.sessionService.log("Default Meta Data Loaded", new Date());
                this.metadataService.getTableViewMetaData(this.view, { }, true).subscribe(result => {
                    console.log(result.meta_data.column_fields);
                    this.columnFields = result.meta_data.column_fields;
                    this.filterFields = result.meta_data.filter_fields;
                    this.viewConditions = result.meta_data.view_conditions;
                    this.viewFormulas = result.meta_data.view_formulas;
                    this.viewSettings = result.meta_data.view_settings;
                    this.enforceClientSidePaging = (this.viewSettings && this.viewSettings.enforce_clientside_paging) ? true : false;
                    this.enforceClientSideSorting = (this.viewSettings && this.viewSettings.enforce_clientside_sorting) ? true : false;
                    this.enforceClientSideFiltering  = (this.viewSettings && this.viewSettings.enforce_clientside_filtering) ? true : false;

                    // initialize current_filters with possible filter_fields to track current filters
                    if (this.enforceClientSideFiltering && this.filterFields) {
                        // close_date: { label: "", value: "" },
                        this.filterFields.forEach(f => {
                            this.current_filters[f.key] = { label: "All", value: "", op: f.op };
                        })
                    }

                    if (this.viewSettings && this.viewSettings.page_size) this.pageSize = this.viewSettings.page_size;
                    this.setActiveSortColumn(this.orderBy);

                    setTimeout(() => {
                        this.loadFilterMetaDeta(this.filterFields, 0);
                    }, 100);
                });
            },
            err => { this.sessionService.log(err) }
        );
    }

    getFormulaResults(item) {
        return this.formulaService.calculateFormulaValuesByItem(this.viewFormulas, item);
    }

    onColumnSort(event) {
        // default to asc = true if switching to a different column, else flip the currect sort state
        this.asc = event.field.key != this.orderBy ? true : !this.asc;
        this.orderBy = event.field.key;
        this.curPage = 1;
        this.setActiveSortColumn(event.field.key);
        if (this.enforceClientSideSorting) {
            this.updateViewableItems();
            //this.sortItems();
        } else {
            this.reloadItems();
        }
    }

    // sortItems() {
    //     var sort_field_key = this.orderBy;
    //     var sort_order = this.asc ? -1 : 1;
    //     this.all_items = this.all_items.sort(function(a, b) {
    //         var a_value = a[sort_field_key];
    //         var b_value = b[sort_field_key];
            
    //         if (a_value < b_value) return sort_order;
    //         if (a_value > b_value) return -1 * sort_order;
    //         if (a_value == b_value) return 0;
    //     });
    //     this.curPage = 1;
    //     this.updateViewableItems();
    // }

    setActiveSortColumn(column_key:string) {
        for (var i = 0; i < this.columnFields.length; i++) {
            var field = this.columnFields[i];
            field.sort_active = (field.key == column_key);
        }
    }

    updateViewableItems() {
        var item_index = (this.curPage - 1) * this.pageSize;
        var view_items = this.all_items;//.slice(item_index, item_index + this.pageSize);
        if (this.enforceClientSideFiltering) {
            view_items = view_items.filter(i => {
                var bInclude = true;
                for (var f in this.current_filters) {
                    // special ALL filter which include all values
                    if (this.current_filters[f].label == "All" && this.current_filters[f].value == "") break;
                    var filter_field = this.filterFields.find(ff => f == ff.key);
                    if (!filter_field.is_serverside_filter) {
                        switch (filter_field.op) {
                            case "=": bInclude = bInclude && (i[f] == this.current_filters[f].value); break;
                            case "!=": bInclude = bInclude && (i[f] != this.current_filters[f].value); break;
                        }
                        if (!bInclude) break;
                    }
                }
                return bInclude;
            })
        }
        if (this.enforceClientSideSorting) {
            var sort_field_key = this.orderBy;
            var sort_order = this.asc ? -1 : 1;
            var columnFields = this.columnFields;
            view_items = view_items.sort(function(a, b) {
                var a_value = a[sort_field_key];
                var b_value = b[sort_field_key];

                var field = columnFields.find(f => f.key == sort_field_key);
                if (field.display_type == DateField.control_type) {
                    a_value = Date.parse(a_value);
                    b_value = Date.parse(b_value);
                }
                
                if (a_value < b_value) return sort_order;
                if (a_value > b_value) return -1 * sort_order;
                if (a_value == b_value) return 0;
            });
        }
        this.itemCount = view_items.length;
        this.pageCount = Math.ceil(this.itemCount / this.pageSize);
        this.items = view_items.slice(item_index, item_index + this.pageSize);
    }

    getUniqueFieldValueForFilter(items, filter_field) {
        var distinct = [];
        for (var i = 0; i < items.length; i++) {
            if (distinct.indexOf(items[i][filter_field.key]) < 0) {
                distinct.push(items[i][filter_field.key]);
            }
        }

        var distinct = distinct.sort();
        var filter_values = [];
        distinct.forEach(d => {
            filter_values.push({ label: d, value: d });
        })
        if (filter_values.length > 0) {
            filter_values.unshift({label: "All", value: "" });
        }
        
        return filter_values;
    }
   
    reloadItems(searchText:string = null) {
        this.isLoading = true;
        var params = this.getSearchParams(this.getExecuteScriptType(true, false));
        if (searchText) params.text = searchText;
        this.apiService.getViewData(this.view, params).subscribe(
            result => {
                this.bServerReloadRequired = false;
                result.items.forEach(i => {
                    if (this.viewConditions) {
                        var conditions = JSON.parse(JSON.stringify(this.viewConditions));                    
                        i.viewConditions = this.conditionService.evaluateItemValues(conditions, null, i);
                    }
                });
                this.all_items = result.items;
                this.curPage = 1;
                this.updateViewableItems();
                this.isLoading = false;
                if (this.enforceClientSideFiltering) {
                    this.filterFields.forEach(f => {
                        if (f.is_column_filter) {
                            this.data_filters[f.key] = this.getUniqueFieldValueForFilter(this.all_items, f);
                        }
                    })
                }
            },
            err => {
                console.log(err);
            }
        );

        if (!this.enforceClientSidePaging) {
            var params = this.getSearchParams(this.getExecuteScriptType(false, true));
            if (searchText) params.text = searchText;
            this.apiService.getViewData(this.view, params).subscribe(
                result => {
                    this.itemCount = result.total_count;
                    this.pageCount =  Math.ceil(this.itemCount / this.pageSize);
                },
                err => {
                    console.log(err);
                }
            );        
        }
    }

    getExecuteScriptType(bSearchData:boolean = true, bTotalCount:boolean = true) {
        if (bSearchData && bTotalCount) return "ST_All";
        if (bSearchData) return "ST_Search";
        if (bTotalCount) return "ST_TotalCount";
    }
    

    // gather all search params in json format to be used as request string parameter
    getSearchParams(executeScriptType:string = null) {
        var params:any = { }
        params.p = this.curPage;
        params.ps = this.pageSize;
        params.ob = this.orderBy;
        if (executeScriptType) params.est = executeScriptType;
        params.obd = this.asc ? "asc" : "desc";
        var filter = [];
        this.filterFields.forEach(f => {
            filter.push({ field: f.key, op: f.op, value: this.current_filters[f.key].value.length > 0 ? this.current_filters[f.key].value : null })
        });

        params.f = JSON.stringify(filter);
    
        return params;
    }

    onPageChange(event) {
        var newPage = event.target.value;
        if (newPage > this.pageCount) newPage = this.pageCount;
        if (newPage < 1) newPage = 1;
        if (this.curPage != newPage) {
            this.curPage = newPage;
            if (this.enforceClientSidePaging && !this.bServerReloadRequired) {
                this.updateViewableItems(); 
            } else {
                this.reloadItems(this.searchText);
            }
        } else {
          event.target.value = this.curPage;
        }
    }

    prevPage() {
        if (this.curPage > 1) {
            this.curPage--;
            if (this.enforceClientSidePaging && !this.bServerReloadRequired) {
                this.updateViewableItems(); 
            } else {
                this.reloadItems(this.searchText);
            }
        }
    }

    nextPage() {
        if (this.curPage < this.pageCount) {
            this.curPage++;
            if (this.enforceClientSidePaging && !this.bServerReloadRequired) {
                this.updateViewableItems(); 
            } else {
                this.reloadItems(this.searchText);
            }
        }
    }

    filter(column, filter) {
        this.current_filters[column] = filter;
        var filter_field = this.filterFields.find(f => f.key == column);
        if (filter_field.is_serverside_filter) this.bServerReloadRequired = true;
        this.curPage = 1;
        if (this.enforceClientSidePaging && !this.bServerReloadRequired) {
            this.updateViewableItems(); 
        } else {
            this.reloadItems(this.searchText);
        }
    }

    onColumnFilter(event) {
        this.filter(event.field.key, event.event);
    }

    onValueChanged(event) {
        var item = event.item;
        var change = event.change;

        let dlg = this.showCustomPromptDlg(item, { msg: "Updating..." });
        // for non-portal sales, also pass sr_order_ID, and sr_close_date along for BoB placeholder deal creation
        if (item.view_ID == null) {
            change.sr_order_ID = item.sr_order_ID;
            change.sr_close_date = item.sr_close_date;
        }
        this.uscStoreService.processActionOnViewItem(this.view, item.view_ID, this.uscStoreService.action_update_book_of_business, change).subscribe(
          result => { 
            dlg.dismiss();
            this.reloadItems(); 
          }
        );
    }

    showCustomPromptDlg(item, msg_config):NgbModalRef {
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.parentView = this.view;
        modalRef.componentInstance.data = item;
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
        modalRef.componentInstance.msg_config = msg_config;
        return modalRef;
    }

    isColumnVisible(column) {
        switch (column.key) {
            case 'ur_firstname':
            case 'ur_lastname':
            case 'ur_team_name':
                return this.uscStoreService.isLeader();
            default:
                return column.visible;
        }
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-book-of-business/usc-book-of-business.component.ts